import { useNavigate } from "react-router-dom";
import { Search, MapPin, Bot, Bookmark } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

const field = "h-11 w-full rounded-xl border border-border bg-card pl-10 pr-3 text-sm placeholder:text-muted-foreground/80 outline-none focus:border-primary/50 transition-colors";
const toggle = (on) => cn("h-11 px-4 rounded-xl border text-sm font-medium inline-flex items-center gap-2 transition-colors",
  on ? "border-primary/50 text-primary bg-primary/[0.07]" : "border-border text-foreground/85 hover:border-foreground/25");

export function JobsToolbar({ f, set, savedCount, auto }) {
  const nav = useNavigate();
  return (
    <div className="flex flex-wrap items-center gap-2.5" data-testid="jobs-toolbar">
      <label className="relative flex-1 min-w-[220px]">
        <span className="sr-only">Search roles</span>
        <Search className="h-4 w-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input value={f.q} onChange={(e) => set({ q: e.target.value })} placeholder="Role, skill or company" className={field} data-testid="jobs-search" />
      </label>
      <label className="relative w-full sm:w-56">
        <span className="sr-only">Location</span>
        <MapPin className="h-4 w-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input value={f.loc} onChange={(e) => set({ loc: e.target.value })} placeholder="Location, e.g. Muscat" className={field} data-testid="jobs-location" />
      </label>
      <button onClick={() => set({ remote: !f.remote })} aria-pressed={f.remote} className={toggle(f.remote)} data-testid="jobs-remote-toggle">Remote only</button>
      <button onClick={() => set({ savedOnly: !f.savedOnly })} aria-pressed={f.savedOnly} className={toggle(f.savedOnly)} data-testid="jobs-saved-toggle">
        <Bookmark className="h-4 w-4" /> Saved{savedCount ? ` · ${savedCount}` : ""}
      </button>
      <Select value={f.sort} onValueChange={(v) => set({ sort: v })}>
        <SelectTrigger className="h-11 w-[140px] rounded-xl" data-testid="jobs-sort" aria-label="Sort roles"><SelectValue /></SelectTrigger>
        <SelectContent position="popper">
          <SelectItem value="fit" data-testid="jobs-sort-fit">Best match</SelectItem>
          <SelectItem value="new" data-testid="jobs-sort-new">Newest</SelectItem>
        </SelectContent>
      </Select>
      <button onClick={() => nav("/candidate/auto-apply")} className={toggle(auto?.enabled)} data-testid="jobs-auto-apply">
        <Bot className="h-4 w-4" /> Auto-apply {auto?.enabled ? "on" : "off"}
      </button>
    </div>
  );
}
